module.exports = __webpack_public_path__ + "static/img/43_phase_function_Paper_PointsHejduk_Prediction.fd3b686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/43_phase_function_Paper_PointsHejduk_Prediction.png
// module id = nq+n
// module chunks = 0